import { createContext } from "react";

const SidebarContext = createContext<{
  open: boolean;
  selectedSection: string | null;
  setSelectedSection: ((sectionName: string | null) => void) | null;
}>({
  open: false,
  selectedSection: null,
  setSelectedSection: null,
});

export default SidebarContext;
